/** Base path for Zones management (list + create/edit). */
export const ZONES_MANAGEMENT_BASE_PATH =
  "/customer/dsok/access-system/zones-management";
